import { useEffect } from "react";

// Full-screen mobile menu behaviour: body scroll lock, initial focus,
// Escape-to-close, and a Tab focus trap contained within `containerRef`.
export const useFocusTrap = ({ open, containerRef, initialFocusRef, onClose }) => {
  useEffect(() => {
    if (!open) return undefined;

    document.body.style.overflow = "hidden";
    initialFocusRef?.current?.focus();

    const onKeyDown = (e) => {
      if (e.key === "Escape") {
        onClose();
        return;
      }
      if (e.key === "Tab" && containerRef.current) {
        const focusable = containerRef.current.querySelectorAll("a, button");
        if (focusable.length === 0) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    };

    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.body.style.overflow = "";
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [open, containerRef, initialFocusRef, onClose]);
};
